import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { getLoyaltyDetails, getLoyaltyHistory, getCustomerDetails } from "config/Services";
import "./ProductsPage.css";
import CircularProgress from "@mui/material/CircularProgress";
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import { useContext } from "react";
import { UserContext } from "App";
import { getStoreCurrencySymbol } from "../../../../utils/currency";
import "./Points.css";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import RedeemIcon from "@mui/icons-material/Redeem";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import CancelIcon from "@mui/icons-material/Cancel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import breakpoints from "assets/theme/base/breakpoints";
import useGetDevice from "../hooks/useGetDevice";
import LoyaltySectionModal from "./components/loyaltySectionModal";
import { useSnackbar } from "../hooks/SnackbarProvider";
import { getFromLocalStorage } from "../../../../utils/localStorageHelpers";

const RedeemTable = ({ rows }) => {
  const isMobile = useGetDevice();
  return (
    <TableContainer sx={{ width: isMobile ? "94vw" : "100%" }} component={Paper}>
      <Table aria-label="simple table" className="table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Event</TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Order ID
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Invoice Value
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Transaction Type
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Redeemed Points
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Points Worth
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Expiry Date
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Status
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Date
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell component="th" scope="row">
                {row.transactionReason}
              </TableCell>
              <TableCell align="center">{row.orderId}</TableCell>
              <TableCell align="center">{row.cartValue || "NA"}</TableCell>
              <TableCell align="center">{row.transactionType}</TableCell>
              <TableCell align="center">{row.loyaltyPointQuantity}</TableCell>
              <TableCell align="center">{getStoreCurrencySymbol()}{row.loyaltyPointsValue}</TableCell>
              <TableCell align="center">{row.loyaltyPointExpiryOn}</TableCell>
              <TableCell align="center">{row.loyaltyPointStatus}</TableCell>
              <TableCell align="center">{row.transactionOn}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export const Points = () => {
  const showSnackbar = useSnackbar();
  const isMobile = useGetDevice();
  const [datarows, setDatarows] = useState([]);
  const { color, setColor } = useContext(UserContext);
  const [cardData, setCardData] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [isEnterPressed, setIsEnterPressed] = useState(false);
  const navigate = useNavigate();

  let retailId = localStorage.getItem("orgId");
  let customerUidx = getFromLocalStorage("customer_details")?.uidx;
  const customerMobile = JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber;
  const mode = localStorage.getItem("mode");
  const retailType = localStorage.getItem("retailType");
  // let retailId = "WHO000261";
  // let customerUidx = "5cf7f0a2048.448f31f83ae6ab4d5c7dfa93d9727c03";

  useEffect(() => {
    if (customerUidx) {
      fetchLoyaltyDetails(customerUidx);
    }
  }, []);

  const fetchLoyaltyDetails = (uidx) => {
    setLoading(true);
    getLoyaltyDetails(retailId, uidx)
      .then((res) => {
        if (res?.data?.data?.status) {
          const data = res?.data?.data?.data;
          setStats(data);
          setCardData([
            {
              id: 1,
              title: "Total Earned Points",
              icon: <MonetizationOnIcon sx={{ fontSize: 60, color: "black" }} />,
              point: data.totalEarnedPoint,
              value: data.totalEarnedPointValue,
            },
            {
              id: 2,
              title: "Total Redeemed Points",
              icon: <RedeemIcon sx={{ fontSize: 60, color: "black" }} />,
              point: data.totalRedeemedPoint,
              value: data.totalRedeemedPointValue,
            },
            {
              id: 3,
              title: "Total Available Points",
              icon: <PriceCheckIcon sx={{ fontSize: 60, color: "black" }} />,
              point: data.totalAvailablePoint,
              value: data.totalAvailablePointValue,
            },
            {
              id: 4,
              title: "Total Expired Points",
              icon: <RunningWithErrorsIcon sx={{ fontSize: 60, color: "black" }} />,
              point: data.totalExpiredPoint,
              value: data.totalExpiredPointValue,
            },
            {
              id: 5,
              title: "Total Cancelled Points",
              icon: <CancelIcon sx={{ fontSize: 60, color: "black" }} />,
              point: data.totalCancelledPoint,
              value: data.totalCancelledPointValue,
            },
          ]);

          let payload;
          if (res?.data?.data?.data?.customerType === "END_CUSTOMER") {
            payload = {
              customerType: "END_CUSTOMER",
              customerUidx: uidx,
              customerOrgId: null,
              sourceOrgId: retailId,
              configId: res?.data?.data?.data?.configurationId,
            };
          } else {
            payload = {
              customerType: res?.data?.data?.data?.customerType,
              customerUidx: null,
              customerOrgId: retailId,
              sourceOrgId: retailId,
              configId: res?.data?.data?.data?.configurationId,
            };
          }

          getLoyaltyHistory(payload)
            .then((response) => {
              if (response?.data?.data?.status) {
                const data = response?.data?.data?.data;
                setDatarows(data);
                showSnackbar(response?.data?.data?.message, "success");
              } else {
                showSnackbar(response?.data?.data?.message, "error");
                setStats({});
              }
            })
            .catch((err) => {
              showSnackbar(err?.response?.data?.message || err?.message, "error");
              setStats({});
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          setStats({});
          showSnackbar(res?.data?.data?.message, "error");
        }
      })

      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearch = () => {
    if (mobileNumber.length !== 10) {
      showSnackbar("Please enter a valid mobile number", "warning");
      return;
    }
    setLoading(true);
    getCustomerDetails({ mobile: mobileNumber })
      .then((res) => {
        fetchLoyaltyDetails(res?.data?.data?.uidx);
      })
      .catch((err) => {
        setStats({});
        showSnackbar("User not found", "error");
        setLoading(false);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isEnterPressed) {
      setIsEnterPressed(true); // Set flag to prevent further calls
      handleSearch();
    }
  };

  const handleKeyUp = (e) => {
    if (e.key === "Enter") {
      setIsEnterPressed(false); // Reset flag when key is released
    }
  };

  const handleProceed = () => {
    isMobile || retailType === "RESTAURANT"
      ? navigate("/restaurant/cart")
      : navigate("/grocery/cart");
  };

  return (
    <Navbar>
      <Box className={color} style={{ display: "flex", flex: 1, flexDirection: "column", marginTop: "3.2rem" }}>
        <div className="loyalty-sticky-header">
          <button
            type="button"
            className="loyalty-back-button"
            onClick={() => navigate(-1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
          </button>
          <h1 className="loyalty-header-title">Loyalty Points</h1>
        </div>
        <Grid container className="loyalty-container">
          {Object.keys(stats).length ? (
            <Grid item xs={12} md={12} className="left-loyalty-container">
              <TextField
                className="search-txt-input-wrapper"
                size="small"
                variant="outlined"
                type="tel"
                onChange={(e) => setMobileNumber(e.target.value)}
                // onKeyDown={(e) => {
                //   if (e.key === "Enter") {
                //     handleSearch();
                //   }
                // }}
                onKeyDown={handleKeyDown}
                onKeyUp={handleKeyUp}
                placeholder="Enter Mobile Number"
                InputLabelProps={{ shrink: false }}
                inputProps={{ maxLength: 10 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <IconButton
                        className="icon-btn-point"
                        aria-label="search"
                        onClick={handleSearch}
                        size="small"
                        sx={{
                          ml: 1,
                          "&:hover": {
                            background: "none",
                          },
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {loading ? (
                <div className="enter-number">
                  <CircularProgress />
                </div>
              ) : (
                <>
                  <Box sx={{ marginBottom: "1rem" }}>
                    <Typography variant="h6" className="title-text" gutterBottom component="div">
                      Reward Points Stats{" "}
                      <div style={{ display: isMobile ? "none" : "block" }}>
                        <div style={{ fontWeight: "normal", fontSize: "15px" }}>
                          Account Created on: {stats?.createdOn}
                        </div>
                        <div style={{ fontWeight: "normal", fontSize: "15px" }}>
                          Last Updated on: {stats?.updatedOn}
                        </div>
                      </div>
                    </Typography>
                    <Grid container spacing={2}>
                      {cardData.map((item) => (
                        <Grid key={item.id} item xs={12} md={6}>
                          <div className="boxcontainer">
                            <div style={{ display: "flex", width: "100%" }}>
                              <div className="item-container">
                                <div style={{ minWidth: "10%" }}>
                                  <Avatar sx={{ width: 80, height: 80, bgcolor: "#C8F5FC" }}>
                                    {item.icon}
                                  </Avatar>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    width: "70%",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      style={{
                                        float: "left",
                                        fontSize: "30px",
                                        fontWeight: "bold",
                                        marginRight: "0.5rem",
                                      }}
                                    >
                                      {item.point}
                                    </div>
                                    <span style={{ color: "gray" }}>(worth {getStoreCurrencySymbol()}{item.value})</span>
                                  </div>
                                  <div
                                    style={{
                                      float: "left",
                                      fontSize: "14px",
                                      color: "gray",
                                    }}
                                  >
                                    {item.title}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                  <Box sx={{ marginBottom: "1rem" }}>
                    <Typography variant="h6" className="title-text" gutterBottom component="div">
                      Redeem Reward Points
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        {isMobile ? (
                          <LoyaltySectionModal customerMobile={customerMobile} />
                        ) : (
                          <div className="boxcontainer">
                            <div style={{ display: "flex", width: "100%" }}>
                              {/* <Typography
                              variant="h7"
                              sx={{ fontWeight: "bold", width: "18rem" }}
                              gutterBottom
                              component="div"
                            >
                              Enter Reward Points To Redeem
                            </Typography> */}

                              <div className="proceed-wrapper-box">
                                {/* <TextField
                                sx={{ marginLeft: "2rem", width: "50%" }}
                                size="small"
                                variant="outlined"
                                type="number"
                                placeholder="Enter Reward Points"
                                InputLabelProps={{ shrink: false }}
                              /> */}
                                <button className="redeemBtn" onClick={handleProceed}>
                                  PROCEED
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </Box>

                  <Box>
                    <Typography variant="h6" className="title-text" gutterBottom component="div">
                      Reward Points Details
                    </Typography>
                    <RedeemTable className="redeem-table-wrapper" rows={datarows} />
                  </Box>
                </>
              )}
            </Grid>
          ) : (
            <Grid item xs={12} md={12} className="left-loyalty-container">
              <TextField
                size="small"
                variant="outlined"
                type="tel"
                onChange={(e) => setMobileNumber(e.target.value)}
                // onKeyDown={(e) => {
                //   if (e.key === "Enter") {
                //     handleSearch();
                //   }
                // }}
                onKeyDown={handleKeyDown}
                onKeyUp={handleKeyUp}
                placeholder="Enter Mobile Number"
                InputLabelProps={{ shrink: false }}
                inputProps={{ maxLength: 10 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <IconButton
                        className="icon-btn-point"
                        aria-label="search"
                        onClick={handleSearch}
                        size="small"
                        sx={{
                          ml: 1,
                          "&:hover": {
                            background: "none",
                          },
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {loading ? (
                <div className="enter-number">
                  <CircularProgress />
                </div>
              ) : (
                <div className="enter-number">Enter mobile number to fetch reward details</div>
              )}
            </Grid>
          )}
        </Grid>
      </Box>
    </Navbar>
  );
};
